import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_6 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_form_item, {
                  label: "Produto",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_produto, {
                      codigoSelecionado: _ctx.state.codigoProduto,
                      "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.codigoProduto) = $event)),
                      descricaoSelecionado: _ctx.state.descricaoSelecionado,
                      "onUpdate:descricaoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.descricaoSelecionado) = $event)),
                      empresas: _ctx.props.empresas,
                      modoDefinicaoProduto: true,
                      apresentarCodigoInterno: true,
                      tipoPCP: true
                    }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "empresas"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_form_item, {
                  label: "UN",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_unidade_produto_movimento, {
                      codigoProdutoDefinicao: _ctx.state.codigoProduto,
                      "onUpdate:codigoProdutoDefinicao": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.codigoProduto) = $event)),
                      sigla: _ctx.state.sigla,
                      "onUpdate:sigla": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.sigla) = $event)),
                      codigoUnidadeSelecionada: _ctx.state.codigoUnidade,
                      "onUpdate:codigoUnidadeSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.codigoUnidade) = $event)),
                      empresas: _ctx.props.empresas,
                      apresentarApenasSigla: true,
                      quantidadeCasasDecimais: _ctx.state.CasasDecimais
                    }, null, 8, ["codigoProdutoDefinicao", "sigla", "codigoUnidadeSelecionada", "empresas", "quantidadeCasasDecimais"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_form_item, {
                  label: "Quantidade",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      valor: _ctx.state.quantidade,
                      "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.quantidade) = $event))
                    }, null, 8, ["valor"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary",
                  style: {"width":"100%","margin-top":"5px","margin-bottom":"5px"},
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.adicionar(_ctx.state.codigoProdutoSelecionado)))
                }, _toDisplayString(_ctx.state.codigoProdutoSelecionado === -1 ? 'Adicionar' : 'Editar'), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_card, {
          titulo: "ETAPAS",
          class: "ss-padding-separacao-esquerda"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              columns: _ctx.gradeBase.colunas.filter(item => item.visible),
              "data-source": _ctx.computedProdutoAcabado,
              rowKey: "codigo",
              pagination: false,
              size: "small",
              loading: _ctx.gradeBase.buscandoDados
            }, {
              bodyCell: _withCtx(({ column, index, text, record }) => [
                (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.editar(index))
                      }, [
                        _createVNode(_component_icone, { nome: "editar" })
                      ], 8, _hoisted_7),
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.excluir(index))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_8)
                    ]))
                  : _createCommentVNode("", true),
                (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                  : _createCommentVNode("", true),
                (column.key ==='quantidade')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}